import { app } from '../../../../app';
import { Controller } from './company-list.controller';
app.component('companySPAdminCompanyList', {
    bindings: {companies: '<'},
    controller: Controller,
    templateUrl: require('./company-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/company-list/company-list.component.js